export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9c03f879b676d938948aeb0a35e52c39.jpg"
          alt="대한효복지센터 히어로"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/80 via-stone-800/60 to-stone-700/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 pt-24 w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 bg-amber-600/20 backdrop-blur-sm border border-amber-500/30 rounded-full px-4 py-2 mb-8">
            <div className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></div>
            <span className="text-amber-300 text-sm font-medium">활동지원사와 함께 성장하는 복지 플랫폼</span>
          </div>

          <h1 className="text-6xl font-bold text-white leading-tight mb-6">
            함께 걷는 길,<br />
            <span className="text-amber-400">더 나은 내일을</span><br />
            만들어갑니다
          </h1>

          <p className="text-white/80 text-xl leading-relaxed mb-10 max-w-xl">
            대한효복지센터는 장애인과 활동지원사가 함께 성장하는<br />
            따뜻한 복지 생태계를 만들어 나갑니다.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => handleScroll('#mission')}
              className="px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white rounded-full font-semibold text-base transition-all cursor-pointer whitespace-nowrap"
            >
              센터 알아보기
            </button>
            <button
              onClick={() => handleScroll('#counseling')}
              className="px-8 py-4 bg-white/15 hover:bg-white/25 backdrop-blur-sm text-white border border-white/40 rounded-full font-semibold text-base transition-all cursor-pointer whitespace-nowrap"
            >
              상담 신청하기
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full z-10">
        <div className="max-w-7xl mx-auto px-8 pb-12 flex items-end justify-between">
          <div className="flex gap-10">
            {[
              { num: '1,200+', label: '등록 활동지원사' },
              { num: '850+', label: '지원 장애인 가족' },
              { num: '15년', label: '복지 서비스 경력' },
            ].map((stat) => (
              <div key={stat.label}>
                <p className="text-3xl font-bold text-white">{stat.num}</p>
                <p className="text-white/60 text-sm mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
          <button
            onClick={() => handleScroll('#mission')}
            className="flex items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            <span className="text-sm">스크롤하여 탐색</span>
            <div className="w-8 h-8 flex items-center justify-center border border-white/40 rounded-full animate-bounce">
              <i className="ri-arrow-down-line text-sm"></i>
            </div>
          </button>
        </div>
      </div>
    </section>
  );
}
